export enum SubscriptionTags {
  subscriptionDetails = "subscriptionDetails",
  plans = "plans",
  addons = "addons",
  invoices = "invoices",
  upcomingInvoices = "upcomingInvoices",
  invoicePreview = "invoicePreview",
}
